import ChordSections from './components/ChordSections';
import Header from './components/Header';
import PlayBar from './components/PlayBar';
import { useAppSelector } from './global/hooks';
import { init, selectInit } from './store/appSlice';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as Tone from 'tone';

function App() {
	const isInit = useAppSelector(selectInit);

	const dispatch = useDispatch();

	const isWindowDefined = window != null;
	const handleInitClick = useCallback(() => {
		if (isInit) return;
		dispatch(init());
		if (isWindowDefined) {
			Tone.start();
		}
	}, [dispatch, isInit, isWindowDefined]);

	// Init effect
	useEffect(() => {
		window?.addEventListener('click', handleInitClick);
		return () => window?.removeEventListener('click', handleInitClick);
	}, [handleInitClick]);

	return (
		<div className="App">
			<Header />
			<ChordSections />
			<PlayBar />
		</div>
	);
}

export default App;
